import { createContext, useContext, useState, useCallback } from 'react';

const PopupContext = createContext();

export function PopupProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [packageInfo, setPackageInfo] = useState({ title: '', amount: 0, tmSignUpType: 1 });

  const openPopup = useCallback((pkgTitle = 'Essentials', pkgAmount = 45, signUpType = 1) => {
    setPackageInfo({ title: pkgTitle, amount: pkgAmount, tmSignUpType: signUpType });
    setIsOpen(true);
  }, []);

  const closePopup = useCallback(() => {
    setIsOpen(false);
    setPackageInfo({ title: '', amount: 0, tmSignUpType: 1 });
  }, []);

  return (
    <PopupContext.Provider value={{ isOpen, openPopup, closePopup, packageInfo }}>
      {children}
    </PopupContext.Provider>
  );
}

export const usePopup = () => useContext(PopupContext);
